import { useEffect, useRef, useState } from 'react'
import './secret-codes-landing.styles.scss';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import SecretCodesList from './secret-codes-list.component';
import SecretCodesForm from './secret-codes-form.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import SecretCodesUpload from './secret-codes-upload.component';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';
import { useEffectiveMembership } from '@/utils/useEffectiveMembership';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';


const SecretCodesLandingPage = ({
  gameElements,
  gameStats,
  gameData,
  playerList,
  role
}) => {

  const membership = useEffectiveMembership();
  const [showUpgradeModal, setShowUpgradeModal] = useState(null);
  const [secretCodesFromDb, setSecretCodesFromDb] = useState({});
  const secretCodesRef = useRef();
  const secretCodesListenerRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();

  const gameId = gameData?.gameId;
  const isPreview = location.pathname.includes('/preview/manager/');

  useEffect(() => {
      if (!gameData?.gameName) return;
      changeDocumentTitle(`Secret Codes | Manage ${gameData.gameName}`);
  }, [gameData?.gameName])

  useEffect(() => {
    function checkMembership(e) {
      const element = 'secretCodes'
      const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'element': element })
      // console.log(res);

      if (res.disabled) {
        if (!membershipRestrictions) return;
        let message = ''
        const planRest = membershipRestrictions[membership.membership];
        if (res.disabledReason.includes(element)) {
          message = `While using the ${planRest.title}, you are not able to access Secret Codes.`;
        }
        setShowUpgradeModal(message)
        return;
      }
    }
    checkMembership();
  }, [gameData, membership])

  useEffect(() => {
    if (!gameId) return;
    function getGameElementsToManage() {
      if (isPreview) {
        if (!completeGameElementData) return;
        const secretCodeObj = {};
        Object.values(completeGameElementData)
          .filter(e => e.type === 'secretCode' && e.status === 'active')
          .forEach(e => {
            secretCodeObj[e.id] = e;
          });
        setSecretCodesFromDb(secretCodeObj);
        return;
      }
      getCollectionFromDb({
        "collection": `games/${gameData.gameId}/gameElements`,
        "query1": {
          "key": "type",
          "condition": "==",
          "value": "secretCode"
        },
        "callback": callback,
        "handleListener": handleListener
      })
      function callback(data) {
        secretCodesRef.current = {
          ...secretCodesRef.current,
          ...{ [data.id]: data }
        }
        setSecretCodesFromDb(secretCodesRef.current);
      }
      function handleListener(data) {
        secretCodesListenerRef.current = data;
      }
    }
    getGameElementsToManage();
    return () => {
      if (secretCodesListenerRef.current) {
        secretCodesListenerRef.current();
        secretCodesListenerRef.current = null;
      }
    }
  }, [gameId, isPreview, completeGameElementData])

  return (
    <div className='secret-codes-landing'>
      <Routes>
        <Route path='' element={
          <div className='g-card secret-codes-card'>
            <BackButton cancel={() => navigate(-1)} />
            <div className="g-space-1"></div>
            <div className='card-title'>
              <ImageContainer src='/images/icons/secret2.png' alt='secret codes icon' className='head-icon' />
              Create and Edit Secret Codes
              {/* <div className='buttons'>
                                <button 
                                    type='button' 
                                    className='g-button med-btn' 
                                    onClick={() => checkMembership('create')}>
                                    Create New Code
                                    <FontAwesomeIcon icon={faPlus} />
                                </button>
                                <button 
                                    type='button' 
                                    className='g-button med-btn' 
                                    onClick={() => checkMembership('upload')}>
                                    <FontAwesomeIcon icon={faUpload} />
                                </button>
                            </div> */}
            </div>
            <hr />
            <div className='secret-codes-landing-content'>
              <SecretCodesList
                gameElements={gameElements}
                secretCodesFromDb={secretCodesFromDb}
                gameData={gameData}
                role={role}
              />
            </div>
          </div>
        }></Route>
        <Route path='create' element={
          <SecretCodesForm
            gameElements={gameElements}
            secretCodesFromDb={secretCodesFromDb}
            gameData={gameData}
            gameStats={gameStats}
            playerList={playerList}
            role={role} />
        }></Route>
        <Route path='edit/:secretCodePath' element={
          <SecretCodesForm
            gameElements={gameElements}
            secretCodesFromDb={secretCodesFromDb}
            gameData={gameData}
            gameStats={gameStats}
            playerList={playerList}
            role={role} />
        }></Route>
        <Route path='upload' element={
          <SecretCodesUpload
            gameData={gameData}
            gameElements={gameElements}
            secretCodesFromDb={secretCodesFromDb}
            playerList={playerList}
            role={role} />
        }></Route>
        <Route path="*" element={<Navigate replace to="/404" />} />
      </Routes>
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal}
      />
    </div>
  )
}

export default SecretCodesLandingPage